export default "__VITE_ASSET__B1WABJ7$__"